<template>
  <div class="pg-text">
    <text-question v-model="sectionData.content" />
  </div>
</template>

<script setup>
import { defineModel } from "vue";
import TextQuestion from "@/components/TextQuestion.vue";

const sectionData = defineModel({ type: Object, required: true });
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.pg-text {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
